<template>
  <MRow class="flex flex-1 -mt-4">
    <MCol class="flex flex-1 flex-col mb-4">
      <MRow class="justify-center" style="height: 30vh">
        <MCol class="flex flex-1">
          <div class="left-top-dots" />
        </MCol>
        <MCol :size="4" />
        <MCol class="flex flex-1">
          <div class="right-top-dots" />
        </MCol>
      </MRow>
      <MRow class="justify-center">
        <MCol :size="6" class="my-4 flex items-center justify-center">
          <div class="flex flex-1">
            <MainSvg class="w-full" />
          </div>
        </MCol>
      </MRow>
      <MRow>
        <MCol :size="12">
          <h2 class="text-center font-normal">
            <b>{{ $t('oops') }}! </b>{{ $t('404_message') }}
          </h2>
          <div class="text-center">
            <FlotoLink as-button :to="homeRoute">
              {{ $t('go_to_home') }}
            </FlotoLink>
          </div>
        </MCol>
      </MRow>
    </MCol>
  </MRow>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import MainSvg from '../svg/404.svg'

export default {
  name: 'SystemError404',
  components: { MainSvg },
  page: {
    title: '404NotFound',
    meta: [{ name: 'description', content: '404' }],
  },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...authComputed,
    homeRoute() {
      if (this.isPortalLogin) {
        return this.$modules.getModuleRoute('support-portal')
      }
      return this.$modules.getModuleRoute('dashboard')
    },
  },
}
</script>
